module.exports = __webpack_public_path__ + "img/tip-error.777faec8.png";